import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getInitialDataAPI,
  getInstitutionListAPI,
  getStatusOfAlertsAPI,
  getStatusOfDialogsAPI,
  getStatusOfManagerAPI,
  getUsageByMostUsedBotAPI,
  getUsageByRobotAPI,
  getUsageByTimeAPI,
  getUsageByTopicAPI,
  getUsageDetectedFaceAPI,
  getUsagePurposeByBotAPI,
} from '../api/dashboard';
import { getAliveList, piboDisconnect, piboInit, setGroup } from '../pibo';
import { signinAPI } from '../api/auth';

const initialState = {
  loading: {
    0: false,
    6: false,
    7: false,
    9: false,
    10: false,
    11: false,
    12: false,
  },
  institutionList: [],
  institution: '',
  robots: [],
  status: {
    supply: 0,
    manager: 0,
    use: 0,
    alerts: 0,
    dialogs: 0,
    useRobots: [],
  },
  token: '',
  data: { 0: [], 6: null, 7: [], 9: null, 10: null, 11: null, 12: null },
};
const name = 'dashboard';

export const getListData = createAsyncThunk(
  `${name}/GET_LIST`,
  async (_undefined, { rejectWithValue }) => {
    try {
      piboDisconnect();
      const { result, data } = await getInstitutionListAPI();
      if (result) {
        return data;
      }
      return rejectWithValue('해당 기관 정보가 없습니다.');
    } catch (error) {
      return rejectWithValue(
        '알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.',
      );
    }
  },
);

export const getInitialData = createAsyncThunk(
  `${name}/GET_INITIAL`,
  async ({ institution, id }, { rejectWithValue }) => {
    try {
      piboDisconnect();
      const { result, data } = await getInitialDataAPI({ institution, id });
      if (result) {
        const { list } = data;
        const serials = list.map(({ serial }) => serial);
        piboInit(serials);
        return { institution, list, count: list.length };
      }
      return rejectWithValue('해당 기관 정보가 없습니다.');
    } catch (error) {
      return rejectWithValue(
        '알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.',
      );
    }
  },
);

const getStatusOfDialogs = createAsyncThunk(
  `${name}/GET_STATUS_DIALOGS`,
  async (robots, { rejectWithValue }) => {
    try {
      const { result, count } = await getStatusOfDialogsAPI({ robots });
      if (result) return count;
      return rejectWithValue(0);
    } catch (error) {
      return rejectWithValue(0);
    }
  },
);
const getStatusOfAlerts = createAsyncThunk(
  `${name}/GET_STATUS_ALERTS`,
  async (robots, { rejectWithValue }) => {
    try {
      const { result, count } = await getStatusOfAlertsAPI({ robots });
      if (result) return count;
      return rejectWithValue(0);
    } catch (error) {
      return rejectWithValue(0);
    }
  },
);
const getStatusOfManager = createAsyncThunk(
  `${name}/GET_STATUS_MANAGER`,
  async (institution, { rejectWithValue }) => {
    try {
      const { result, count } = await getStatusOfManagerAPI({ institution });
      if (result) return count;
      return rejectWithValue(0);
    } catch (error) {
      return rejectWithValue(0);
    }
  },
);
export const getStatusOfUsingRobots = createAsyncThunk(
  `${name}/GET_STATUS_USING_ROBOTS`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const list = getAliveList();
      if (list) {
        const { robots: rs } = getState().dashboard;
        const useRobots = rs.reduce((acc, { serial }) => {
          if (list.find((v) => v === `r_${serial}`)) {
            return [...acc, serial];
          }
          return acc;
        }, []);
        return { use: list.length, useRobots };
      }
      return rejectWithValue(0);
    } catch (error) {
      return rejectWithValue(0);
    }
  },
);

export const getUsageByRobot = createAsyncThunk(
  `${name}/GET_USAGE_BY_ROBOTS`,
  async (type, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsageByRobotAPI({
        type,
        robots,
      });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const getUsageByTime = createAsyncThunk(
  `${name}/GET_USAGE_BY_TIME`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsageByTimeAPI({ robots });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const getUsageByMostUsedBot = createAsyncThunk(
  `${name}/GET_USAGE_BY_MOST_USED_BOT`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsageByMostUsedBotAPI({ robots });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const getUsagePurposeByBot = createAsyncThunk(
  `${name}/GET_USAGE_PURPOSE_BY_BOT`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsagePurposeByBotAPI({ robots });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const getUsageByTopic = createAsyncThunk(
  `${name}/GET_USAGE_BY_TOPIC`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsageByTopicAPI({ robots });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const getUsageByDetectedFace = createAsyncThunk(
  `${name}/GET_USAGE_BY_DETECTED_FACE`,
  async (_undefined, { rejectWithValue, getState }) => {
    try {
      const { robots: list } = getState().dashboard;
      const robots = list.map(({ robotId }) => robotId);
      const { result, data } = await getUsageDetectedFaceAPI({ robots });
      if (result) return data;
      return rejectWithValue([]);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);

export const signIn = createAsyncThunk(
  `${name}/SIGN_IN`,
  async ({ userId, password }, { rejectWithValue }) => {
    try {
      const data = await signinAPI(userId, password);
      const { result, token } = data;
      if (result) {
        return { token };
      }
      return rejectWithValue(false);
    } catch (err) {
      const { error } = await err.json();
      if ('code' in error && 'desc' in error) {
        const { code, desc } = error;
        if (code === '4u105b') {
          return rejectWithValue(
            '계정 정보가 존재하지 않습니다. 관리자에게 문의하세요.',
          );
        }
        if (code === '4u105c') {
          return rejectWithValue('아이디 또는 비밀번호가 일치하지 않습니다.');
        }
        return rejectWithValue(desc);
      }
      return rejectWithValue(
        '알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.',
      );
    }
  },
);

const dashboardSlice = createSlice({
  name,
  initialState,
  reducers: {
    refresh: (state, action) => ({
      ...state,
      refresh: true,
      institution: action.payload,
    }),
  },
  extraReducers: {
    [signIn.pending.type]: (state) => ({
      ...state,
      pending: true,
      error: null,
    }),
    [signIn.fulfilled.type]: (state, action) => ({
      ...state,
      pending: false,
      ...action.payload,
    }),
    [signIn.rejected.type]: (state, action) => ({
      ...initialState,
      error: {
        ...state.error,
        login: action.payload || '로그인에 실패하였습니다.',
      },
    }),
    [getListData.fulfilled.type]: (state) => ({
      ...state,
      loading: { ...state.loading, list: true },
    }),
    [getListData.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, list: false },
      institutionList: action.payload,
    }),
    [getListData.rejected.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, list: false },
      error: action.payload,
    }),
    [getInitialData.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 0: true },
      status: {
        supply: 0,
        manager: 0,
        use: 0,
        alerts: 0,
        dialogs: 0,
        useRobots: [],
      },
    }),
    [getInitialData.fulfilled.type]: (state, action) => ({
      ...state,
      refresh: false,
      loading: { ...state.loading, 0: false },
      institution: action.payload.institution,
      robots: action.payload.list,
      status: { ...state.status, supply: action.payload.count },
    }),
    [getInitialData.rejected.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 0: false },
      error: action.payload,
    }),
    [getStatusOfDialogs.fulfilled.type]: (state, action) => ({
      ...state,
      status: { ...state.status, dialogs: action.payload },
    }),
    [getStatusOfDialogs.rejected.type]: (state, action) => ({
      ...state,
      status: { ...state.status, dialogs: action.payload },
    }),
    [getStatusOfAlerts.fulfilled.type]: (state, action) => ({
      ...state,
      status: { ...state.status, alerts: action.payload },
    }),
    [getStatusOfAlerts.rejected.type]: (state, action) => ({
      ...state,
      status: { ...state.status, alerts: action.payload },
    }),
    [getStatusOfManager.fulfilled.type]: (state, action) => ({
      ...state,
      status: { ...state.status, manager: action.payload },
    }),
    [getStatusOfManager.rejected.type]: (state, action) => ({
      ...state,
      status: { ...state.status, manager: action.payload },
    }),
    [getStatusOfUsingRobots.fulfilled.type]: (state, action) => ({
      ...state,
      status: { ...state.status, ...action.payload },
    }),
    [getStatusOfUsingRobots.rejected.type]: (state, action) => ({
      ...state,
      status: { ...state.status, use: action.payload },
    }),
    [getUsageByRobot.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 6: true },
    }),
    [getUsageByRobot.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 6: false },
      data: { ...state.data, 6: action.payload },
    }),
    [getUsageByRobot.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 6: false },
      data: { ...state.data, 6: null },
    }),
    [getUsageByTime.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 7: true },
    }),
    [getUsageByTime.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 7: false },
      data: { ...state.data, 7: action.payload },
    }),
    [getUsageByTime.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 7: false },

      data: { ...state.data, 7: [] },
    }),
    [getUsagePurposeByBot.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 9: true },
    }),
    [getUsagePurposeByBot.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 9: false },
      data: { ...state.data, 9: action.payload },
    }),
    [getUsagePurposeByBot.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 9: false },
      data: { ...state.data, 9: null },
    }),
    [getUsageByMostUsedBot.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 12: true },
    }),
    [getUsageByMostUsedBot.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 12: false },
      data: { ...state.data, 12: action.payload },
    }),
    [getUsageByMostUsedBot.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 12: false },
      data: { ...state.data, 12: null },
    }),
    [getUsageByDetectedFace.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 10: true },
    }),
    [getUsageByDetectedFace.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 10: false },
      data: { ...state.data, 10: action.payload },
    }),
    [getUsageByDetectedFace.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 10: false },
      data: { ...state.data, 10: null },
    }),
    [getUsageByTopic.pending.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 11: true },
    }),
    [getUsageByTopic.fulfilled.type]: (state, action) => ({
      ...state,
      loading: { ...state.loading, 11: false },
      data: { ...state.data, 11: action.payload },
    }),
    [getUsageByTopic.rejected.type]: (state) => ({
      ...state,
      loading: { ...state.loading, 11: false },
      data: { ...state.data, 11: null },
    }),
  },
});

const { reducer: DashboardReducer, actions } = dashboardSlice;
export const { refresh } = actions;

export const getAllStatus = () => async (dispatch, getState) => {
  const { robots: list, institution } = getState().dashboard;
  const robots = list.map(({ robotId }) => robotId);
  const serials = list.map(({ serial }) => serial);

  setGroup(serials);
  dispatch(getStatusOfUsingRobots());
  dispatch(getStatusOfDialogs(robots));
  dispatch(getStatusOfAlerts(robots));
  dispatch(getStatusOfManager(institution));
};

export default DashboardReducer;
